import styled from 'styled-components'

export const Header = styled.div`
  width: 100%;
  height: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 80px;
`

export const Logo = styled.img`
  width: 125px;
  margin-top: 65px;
`

export const Slogan = styled.p`
  line-height: 40px;
  font-weight: bold;
  font-size: 36px;
  width: 540px;
  text-align: center;
  margin-top: 140px;
`
